import { theme } from "#tailwind-config";

export const useTheme = () => theme;
